/**
 * Select the row editing state.
 */
export const gridEditRowsStateSelector = state => state.editRows;